import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { WorkOrder } from '../WorkOrder'

@InputType()
export class CloneWorkOrderArgs extends ActionArgs {
  @Field(() => ID)
  workOrderId: string
}

export interface ICloneWorkOrder extends IAction<WorkOrder, CloneWorkOrderArgs> {}
